export default "__VITE_ASSET__DwK$RcUt__"